// CategoryFilter.jsx
import styles from './CategoryFilter.module.scss'
import { CheckIcon } from '@heroicons/react/20/solid'

export const CategoryFilter = ({ categoryList, selectedCategory, onSelect }) => {
	return (
		<div className={styles.categoryFilter}>
			{['전체', ...categoryList].map((category) => (
				<button
					key={category}
					onClick={() => onSelect(category)}
					className={`${styles.categoryButton} ${selectedCategory === category ? styles.active : ''}`}>
					{category}
					{selectedCategory === category && (
						<CheckIcon style={{ width: '12px', height: '12px' }} />
					)}
				</button>
			))}
		</div>
	)
}
